(() => {
  function reveal(hash, scroll) {
    if (!hash || hash === '#') return;
    const target = document.getElementById(decodeURIComponent(hash.slice(1)));
    const details = target?.matches('.lu-form-disclosure') ? target : target?.querySelector('.lu-form-disclosure') || target?.closest('.lu-form-disclosure');
    if (!details) return;
    details.open = true;
    if (scroll) target.scrollIntoView({block: 'start'});
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link) return;
    const url = new URL(link.href, location.href);
    if (url.origin === location.origin && url.pathname === location.pathname && url.hash) reveal(url.hash, false);
  });
  window.addEventListener('hashchange', () => reveal(location.hash, true));
  document.addEventListener('shopify:section:load', () => reveal(location.hash, false));
  reveal(location.hash, true);
})();
